import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { CsvAsStringArrays } from '@malou-io/package-utils';

import { BoostersStatisticsDataV2 } from '#modules/statistics-boosters/models/boosters.interface';
import { AbstractCsvService } from '#modules/statistics/components/download-insights-modal/models/csv-service.abstract';
import { StatisticsStore } from '#modules/statistics/stores/store/statistics.store';
import { NfcToCsvMapper } from '#shared/helpers/map-nfc-name';

type Data = BoostersStatisticsDataV2 | undefined;

@Injectable()
export class BoostersScanCountCsvInsightV2Service extends AbstractCsvService<Data> {
    private readonly _statisticsStore = inject(StatisticsStore);
    private readonly _nfcToCsvMapper = inject(NfcToCsvMapper);

    protected _getData$(): Observable<Data> {
        return of(this._statisticsStore.boosterStatsDataV2());
    }

    protected override _isDataValid(data: Data): boolean {
        return !!data;
    }

    protected override _getCsvHeaderRow(): string[] {
        return ['Booster', 'Scan count'];
    }

    protected override _getCsvDataRows(data: Exclude<Data, undefined>): CsvAsStringArrays {
        const groupedData = data.nfcs.reduce((acc: string[][], nfc) => {
            const scanCount = data.scans.filter((scan) => nfc.id === scan.nfcId).length;
            const nfcName = this._nfcToCsvMapper.mapNfcName(nfc);
            acc.push([nfcName, scanCount.toString()]);
            return acc;
        }, []);
        return groupedData;
    }
}
